import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FiCheckCircle, FiXCircle } from "react-icons/fi";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Loader from "../../components/Loader/Loader";
import { getConsultationBooking } from "../../api/consultationApi";
import { formatINR, formatSlotDateTime } from "./consultationUtils";
import "./Consultation.css";

export default function ConsultationConfirmation() {
  const [params] = useSearchParams();
  const bookingId = params.get("bookingId");
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(Boolean(bookingId));

  useEffect(() => {
    if (!bookingId) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const result = await getConsultationBooking(bookingId);
        if (!cancelled && result.ok && result.success) setBooking(result.data);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [bookingId]);

  // The booking's own status (set only after PayU's hash is verified) is the
  // source of truth - the ?status= in the URL is just a hint.
  const paid = booking ? booking.status === "paid" || booking.status === "completed" : false;

  return (
    <>
      <Header />
      <section className="cn-section">
        <div className="cn-container cn-result">
          {loading ? (
            <Loader label="Confirming your booking..." />
          ) : paid ? (
            <>
              <FiCheckCircle className="cn-result-icon is-ok" />
              <h1>Booking confirmed</h1>
              <p>Thank you! Your consultation is booked. A confirmation has been sent to your email.</p>
              <dl className="cn-review">
                <div><dt>Reference</dt><dd>{booking.ref}</dd></div>
                <div><dt>Consultation</dt><dd>{booking.serviceTitle}</dd></div>
                <div><dt>Consultant</dt><dd>{booking.consultantName}</dd></div>
                <div><dt>Date &amp; time</dt><dd>{formatSlotDateTime(booking.slotStart)} IST</dd></div>
                <div><dt>Duration</dt><dd>{booking.durationMinutes} minutes</dd></div>
                <div><dt>Amount paid</dt><dd>{formatINR(booking.amount)}</dd></div>
              </dl>
            </>
          ) : (
            <>
              <FiXCircle className="cn-result-icon is-bad" />
              <h1>Payment not completed</h1>
              <p>
                Your payment did not go through, so the booking was not confirmed. No consultation has been
                booked. If money was deducted, it will be refunded by your bank. You can try again below.
              </p>
            </>
          )}
          <div className="cn-actions cn-actions-center">
            <Link className="cn-btn cn-btn-gold" to="/consultation">
              {paid ? "Book another consultation" : "Try again"}
            </Link>
            <Link className="cn-btn cn-btn-ghost" to="/">
              Back to home
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
